// extracted by mini-css-extract-plugin
export var cell = "igpost-module--cell--VUjGl";
export var overlay = "igpost-module--overlay--oaPH2";